import React, { useMemo } from 'react';
import {
  Card, Col, Row
} from 'reactstrap';
import { useSelector } from 'react-redux';
import { AnimatedContent, Typewriter } from 'components/RichInsights';
import { Bar } from 'react-chartjs-2';
import { useParams } from 'react-router-dom'

export default function Visualizations() {
  const richInsights = useSelector((state) => state.insights.richInsights);
  const content = richInsights && richInsights.content ? richInsights.content : {};
  const visualizations = (richInsights
    && richInsights.content
    && richInsights.content.visualizations)
    || [];

  console.log('Rendering Visualizations:', visualizations);

  const rowStyle = useMemo(() => ({
    margin: '0',
    padding: '0'
  }), []);

  return (
    <>
      {visualizations.map((viz) => (
        <Row
          key={viz.title}
          style={rowStyle}
        >
          <Col>
            <Card className="m-0" style={{ padding: '24px' }}>
              <Visualization visualization={viz} content={content} />
            </Card>
          </Col>
        </Row>
      ))}
    </>
  );
}

export function PersonaVisualizations() {
  const params = useParams();
  const personaId = params.personaId;
  const knowledge = useSelector(state => state.knowledge);

  const activeEntity = useMemo(() => {
    if (knowledge.entities) {
      return knowledge.entities.find(entity => entity.id === personaId);
    }

    return null;
  }, [knowledge.entities, personaId]);

  console.log('ACTIVE ENTITY: ', activeEntity);

  const content = activeEntity
    && activeEntity.insights
    && activeEntity.insights.product_affinities
    && activeEntity.insights.product_affinities.content

  const visualizations = content && content.visualizations || []

  return (
    <>
      {visualizations.map((viz) => (
        <Row
          className="persona-visualizations"
          key={viz.title}
          style={{
            margin: '0',
            padding: '0'
          }}
        >
          <Col>
            <Card className="m-0">
              <Visualization visualization={viz} content={content} />
            </Card>
          </Col>
        </Row>
      ))}
    </>
  );
}

function Visualization({ visualization, content }) {
  if (visualization.type === 'bar') {
    return renderVisualization(visualization, content);
  }

  return (
    <div>
      {visualization.type}
      {' '}
      not supported yet.
    </div>
  );
}

function renderVisualization(visualization, content) {
  return (
    <AnimatedContent delay={300} type="fade">
      <div style={{ minHeight: '280px' }}>
        <Bar
          data={visualization.data}
          options={{
            ...content.chartDefaults.options,
            ...visualization.options,
            animation: {
              duration: 2000,
              easing: 'easeInOutQuart'
            }
          }}
        />
      </div>
      {renderChartInsights(visualization.insights)}
    </AnimatedContent>

  );
}

function renderChartInsights(insights) {
  return (
    <AnimatedContent delay={500} type="slideUp">
      <div className="mt-4 p-3 bg-light rounded">
        <h5 className="text-primary mb-3">{insights.title}</h5>
        <Typewriter text={insights.summary} speed={30} />
        <ul className="list-unstyled mt-3">
          {insights.bullets.map((bullet, index) => (
            <AnimatedContent
              key={index}
              delay={800 + index * 200}
              type="slideIn"
            >
              <li className="mb-2">
                <i
                  className="fas fa-circle text-primary mr-2"
                  style={{ fontSize: '8px' }}
                />
                {bullet}
              </li>
            </AnimatedContent>
          ))}
        </ul>
      </div>
    </AnimatedContent>
  );
}
